import { TrendUp, TrendDown } from "@phosphor-icons/react";
import { gainClass } from "../../lib/format";

export default function StatCard({ label, value, sub, delta, testId }) {
  return (
    <div className="glass-card glass-card-hover p-5" data-testid={testId}>
      <p className="label-caps">{label}</p>
      <p className="tnum text-xl md:text-[22px] font-medium tracking-tight mt-3 text-white" data-testid={`${testId}-value`}>
        {value}
      </p>
      {(sub || delta !== undefined) && (
        <div className="flex items-center gap-2 mt-2.5">
          {delta !== undefined && (
            <span className={`inline-flex items-center gap-1 text-xs font-semibold tnum ${gainClass(delta)}`}>
              {delta >= 0 ? <TrendUp size={13} weight="bold" /> : <TrendDown size={13} weight="bold" />}
              {Math.abs(delta * 100).toFixed(2)}%
            </span>
          )}
          {sub && <span className="text-[11px] text-zinc-500">{sub}</span>}
        </div>
      )}
    </div>
  );
}
